// extracted by mini-css-extract-plugin
export var collapsed = "CruiseItineraryPortItem-module--collapsed--a9cbd";
export var dateTime = "CruiseItineraryPortItem-module--date-time--df1a1";
export var dateTimeLabel = "CruiseItineraryPortItem-module--date-time-label--2c19e";
export var dayNumber = "CruiseItineraryPortItem-module--day-number--72091";
export var details = "CruiseItineraryPortItem-module--details--5f627";
export var expand = "CruiseItineraryPortItem-module--expand--f9d8f";
export var item = "CruiseItineraryPortItem-module--item--8fb5a";
export var name = "CruiseItineraryPortItem-module--name--bdcf9";
export var opened = "CruiseItineraryPortItem-module--opened--1b52b";
export var portImage = "CruiseItineraryPortItem-module--port-image--53ea7";
export var portImageContainer = "CruiseItineraryPortItem-module--port-image-container--89993";
export var stopName = "CruiseItineraryPortItem-module--stop-name--a06c7";
export var stopNameInline = "CruiseItineraryPortItem-module--stop-name-inline--7b255";